import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import { hideAllControls, addTubeToRack, removeTubesFromRack, removeTubeFromRack, setSolutionInScene, setModal, showModal, pushInteractions,
  toggleToolTipControlsForFloatingTubeRack , setSolutionOnIce, setSolutionOnRack, addTubeToIceBucket
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  if (state.notebook.protocolSection.scene.apparatus.hasOwnProperty("floatingTubeRack") &&
      state.notebook.protocolSection.scene.apparatus.hasOwnProperty("waterBath") &&
      state.notebook.protocolSection.scene.apparatus.floatingTubeRack.some(
      floatingTubeRack => floatingTubeRack.id === ownProps.id
    )
  ) {
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.floatingTubeRack[ownProps.id-1].type,
      tubes: state.notebook.protocolSection.scene.apparatus.floatingTubeRack[ownProps.id-1].tubes,
      count: state.notebook.protocolSection.scene.apparatus.floatingTubeRack[ownProps.id-1].count,
      inWaterBath: state.notebook.protocolSection.scene.apparatus.floatingTubeRack[ownProps.id-1].inWaterBath,
      inFreezer: state.notebook.protocolSection.scene.apparatus.floatingTubeRack[ownProps.id-1].inFreezer,
      showToolTipControls: state.notebook.protocolSection.scene.apparatus.waterBath[ownProps.id - 1].showToolTipControls,
      interactionProps: {
        waterBathContainsTubeRack: state.notebook.protocolSection.scene.apparatus.waterBath[ownProps.id -1].containsTubeRack,
        solutions: state.notebook.protocolSection.scene.apparatus.solutions
      }
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {

    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    addTubeToRack: (data) => {
      dispatch(addTubeToRack(data))
    }, 
    removeTubesFromRack: (data) => {
      dispatch(removeTubesFromRack(data))
    }, 
    removeTubeFromRack: (data) => {
      dispatch(removeTubeFromRack(data))
    }, 
    setSolutionInScene: (data) => {
      dispatch(setSolutionInScene(data))
    }, 
    setModal: (data) => {
      dispatch(setModal(data))
    }, 
    showModal: (data) => {
      dispatch(showModal(data))
    },

    pushInteractions: (data) =>{
      dispatch(pushInteractions(data))
    },
    toggleToolTipControlsForFloatingTubeRack: (data) =>{
      dispatch(toggleToolTipControlsForFloatingTubeRack(data))
    },
    setSolutionOnIce: (data) => {
      dispatch(setSolutionOnIce(data))
    },

    setSolutionOnRack: (data) => {
      dispatch(setSolutionOnRack(data))
    },

    addTubeToIceBucket: (data) => {
      dispatch(addTubeToIceBucket(data))
    },

  };
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
